import "../../../../content/projects/tveda/tveda.css";
import * as React from 'react';
export default {
  React
};